import { type FC, useEffect, useRef, useState } from "react";

import { InputText, MomentButton } from "@moment/ui";

export const TagLabel: FC<{
	tagLabel: string;
	onTagLabelChange: (tagLabel: string) => void;
}> = ({ tagLabel, onTagLabelChange }) => {
	const [editing, setEditing] = useState(false);
	const ref = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (editing) {
			ref.current?.focus();
		}
	}, [editing]);

	if (editing) {
		return (
			<InputText
				ref={ref}
				className="!-m-px"
				size="sm"
				defaultValue={tagLabel}
				onBlur={(e) => {
					setEditing(false);
					onTagLabelChange(e.target.value);
				}}
				onKeyDown={(e) => {
					if (e.key === "Enter") {
						setEditing(false);
						onTagLabelChange(e.currentTarget.value);
					}
				}}
			/>
		);
	}

	return (
		<MomentButton
			className="!justify-start !px-2"
			size="sm"
			level="tertiary"
			onClick={() => setEditing(true)}
		>
			<div className="!font-normal">{tagLabel}</div>
		</MomentButton>
	);
};
